import {
  CustomizationMobileWorkbenchFeaturePage,
  useCustomizationMobileWorkbenchSession,
} from "..";

/**
 * 定制需求手机临时替代版页面入口。
 */
export function CustomizationMobileWorkbenchPage() {
  const { buildPagePath, runtime } = useCustomizationMobileWorkbenchSession();

  return (
    <CustomizationMobileWorkbenchFeaturePage
      quickItinerary={runtime.sharedRuntime.quickItinerary}
      confirmedTraceCount={runtime.confirmedTraceIds.length}
      createDemandVersion={runtime.createDemandVersion}
      createNewCustomization={runtime.createNewCustomization}
      itineraryPagePath={buildPagePath("itinerary")}
      notifyDispatcher={runtime.notifyDispatcher}
      saveProject={runtime.saveProject}
      selectVersion={runtime.selectVersion}
      startItineraryGeneration={runtime.startItineraryGeneration}
      closeOpportunityBinding={runtime.sharedRuntime.closeOpportunityBinding}
      resolveOpportunityBinding={runtime.sharedRuntime.resolveOpportunityBinding}
      viewModel={runtime.viewModel}
    />
  );
}
